/**
 * Decisiones puras del guard de rutas de eficiencia reproductiva de cría
 * (FRONTEND_INTEGRATION §3). El router hace el `dispatch` y delega acá la decisión, para
 * poder probarla sin montar el router real.
 */

/** Modos de producción con rodeo de cría propio (meta `requiresModo: "cria_propia"`). */
export const MODOS_CRIA_PROPIA = Object.freeze(["solo_cria", "ciclo_completo"]);

/**
 * Modos que aceptan los endpoints `/cria/*` (toros, animales, registrar-servicio). Copia de
 * `MODOS_CRIA` de `require_modo_cria` (Tambo-Back `app/services/cria/access.py`): si el
 * backend cambia esa lista, cambiarla acá. Un modo sin definir (`null`) también pasa.
 */
export const MODOS_API_CRIA = Object.freeze([
  "solo_cria",
  "ciclo_completo",
  "tambo_feedlot",
  "tambo",
]);

/** ¿El backend deja usar `/cria/*` con este modo? Mismo criterio que `require_modo_cria`. */
export function modoPermiteApiCria(modo) {
  return !modo || MODOS_API_CRIA.includes(modo);
}

/** Ruta a la que se manda al usuario cuando la sección no está disponible. */
export const RUTA_SIN_EFICIENCIA = Object.freeze({ name: "cria" });

/** ¿El modo de producción del establecimiento tiene cría propia? */
export function modoPermiteCriaPropia(modo) {
  return MODOS_CRIA_PROPIA.includes(modo);
}

/**
 * Destino del paso `requiresCriaEficiencia` según `verificarHabilitacion`:
 * - `habilitada` → pasa (`null`);
 * - `error` (5xx o red) → pasa: la pantalla muestra «No se pudo cargar» con Reintentar (§6);
 * - `no_habilitada` (404 funcion_no_habilitada), `sin_permiso` (403) o cualquier otro valor
 *   (sin resolver) → `{ name: "cria" }`: la sección se oculta.
 * @param {string} habilitacion
 * @returns {{ name: string } | null}
 */
export function destinoSegunHabilitacion(habilitacion) {
  if (habilitacion === "habilitada" || habilitacion === "error") return null;
  return { ...RUTA_SIN_EFICIENCIA };
}
